import { useFeatureFlag } from "hooks/useFeatureFlag";
import { startedOnOrAfter } from "utils/deterministicReport";

/**
 * Whether to render the deterministic report for one session.
 *
 * Both halves of the gate must hold: the flag is on for this educator, and the
 * session started on or after the cutoff. Every surface the backend-driven
 * updates touch reads this, so a pre-cutoff session keeps the report it was
 * generated with.
 *
 * @param {string|Date|null|undefined} startedAt The session's start time.
 * @returns {boolean}
 */
export const useDeterministicReport = (startedAt) => {
  const flagEnabled = useFeatureFlag("deterministicReportInputs");
  return flagEnabled && startedOnOrAfter(startedAt);
};
